module.exports = __webpack_public_path__ + "img/girl.1a7b9a4b.png";